import { render } from "./monitorDashboard.vue?vue&type=template&id=bb62b272&scoped=true"
import script from "./monitorDashboard.js?vue&type=script&lang=js"
export * from "./monitorDashboard.js?vue&type=script&lang=js"

import "./monitorDashboard.vue?vue&type=style&index=0&id=bb62b272&scoped=true&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bb62b272"]])

export default __exports__